const normalizeStaticHostName = (hosts) => {
    if (hosts.assets) {
        return `${hosts.assets.origin}/assets`;
    }
    if (process.env.NODE_ENV === 'production') {
        return `https://${window.location.host}/assets`;
    }
    return 'https://dev.synchronycredit.com/assets';
};
export default normalizeStaticHostName;
